/* Pages' scope requests */

import buildrzAxios from 'App/clients/buildrzAxios';

import {mapQueryParamsToRestParams} from '../../clients/rest_params_formatting';

import * as pagesConstants from './pages_constants';

let targetRoute: string | null = null;

class HttpError extends Error {
  statusCode: number;
  constructor(errorMessage: string, statusCode: number) {
    super(errorMessage);
    this.statusCode = statusCode;
  }
}

export const handleErrors = async (response: Response) => {
  if (!response.ok) {
    let json;
    try {
      json = await response.text();
    } catch (e) {
      throw Error(`${response.statusText}: ${e}`);
    }
    throw new HttpError(json, response.status);
  }
  return response;
};

export function getTargetRoute(): string | null {
  return targetRoute;
}

export function setTargetRoute(newTargetRoute: string): void {
  targetRoute = newTargetRoute;
}

export function resetTargetRoute(): void {
  targetRoute = null;
}

export function createPage(name: string) {
  return buildrzAxios
    .post(`/${pagesConstants.PAGES_MODEL}/`, {name})
    .then(response => response.data);
}

export function getAllProjectsInCity(inseeCode: string) {
  const query = {
    filter: {city_code: {similar: inseeCode}},
  };
  const params = mapQueryParamsToRestParams(query);
  return buildrzAxios
    .get(`/${pagesConstants.LIGHT_PROJECTGROUPS_MODEL}/`, {params})
    .then(response => response.data.results);
}
